var Bunge = Bunge || {};

Bunge.tabs = (function($) {
    var ui = {};

    function cacheUI() {
        ui.$tabs = $('.tabs');
        ui.$tabsNav = $('.tab__nav');
        ui.$tabsContent = $('.tabs__content');
    }

    function handleTabsNavClick(e) {
        const tabsLink = $(e.target);
        const tabsContent = ui.$tabsContent.find('> div');

        
        if(tabsLink.parent().hasClass('tabs__nav__active')) {
            $(ui.$tabs).toggleClass('expand');
        } else {
            $(ui.$tabs).removeClass('expand');
        }
        tabsLink.parent().siblings().removeClass('tabs__nav__active');
        tabsLink.parent().addClass('tabs__nav__active');

        tabsContent.addClass('d-none');
        ui.$tabsContent.find(tabsLink[0].hash).removeClass('d-none');

        if(ui.$tabsContent.find('> div:first-child').hasClass('d-none')) {
            ui.$tabsContent.addClass('rounded-top-left');
        } else {
            ui.$tabsContent.removeClass('rounded-top-left');
        }
    }

    function registerHandlers() {
        ui.$tabs.find('.tabs__nav a').click(handleTabsNavClick);
    }

    function init() {
        if ($('.tabs').length <= 0) {
            return;
        }
        cacheUI();
        registerHandlers();
    }

    return {
        init: init,
    };
})(jQuery);

$(function() {
    Bunge.tabs.init();
});
